import { useSeo } from "@/hooks/useSeo";
import HeroCarousel from "./components/HeroCarousel";
import CategoryQuickLinks from "./components/CategoryQuickLinks";
import LatestVideos from "./components/LatestVideos";
import HotRanking from "./components/HotRanking";
import AboutSection from "./components/AboutSection";

export default function Home() {
  useSeo({
    title: "呱呱视频社区 - 多元视频分享平台和互动社区",
    description:
      "呱呱视频社区为用户提供丰富多样的视频内容与分享交流平台，涵盖短视频、娱乐、生活等多类视频，方便用户观看、上传和互动。",
    keywords: "呱呱视频社区,视频分享,在线视频,视频社区,短视频平台,互动社区,娱乐视频,生活视频",
  });

  return (
    <div className="w-full">
      <HeroCarousel />
      <CategoryQuickLinks />
      <section className="max-w-[1280px] mx-auto px-4 md:px-6 pb-12">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
          <div className="flex-1 min-w-0">
            <LatestVideos />
          </div>
          <div className="w-full lg:w-[320px] shrink-0">
            <HotRanking />
          </div>
        </div>
      </section>
      <AboutSection />
    </div>
  );
}